import { useState } from 'react'
import { demoScenarios } from './demoScenarios'
import { loadLatestEpisode, saveEpisode } from './storage'

export default function DemoScenarioPanel() {
  const [loading, setLoading] = useState<string | null>(null)

  const loadScenario = async (scenarioId: string) => {
    const scenario = demoScenarios.find((item) => item.id === scenarioId)
    if (!scenario || loading) return

    setLoading(scenario.id)
    try {
      const active = await loadLatestEpisode()
      if (active) {
        const replace = window.confirm('È già presente un episodio attivo sul dispositivo. Chiuderlo e caricare lo scenario sintetico selezionato?')
        if (!replace) return
        await saveEpisode({ ...active, status: 'closed' })
      }

      await saveEpisode(scenario.build(new Date()))
      window.location.reload()
    } finally {
      setLoading(null)
    }
  }

  return (
    <details className="demo-launcher">
      <summary>Scenari demo</summary>
      <div className="demo-launcher-body">
        <strong>Test del percorso guidato</strong>
        <p>Carica un episodio interamente sintetico nella timeline locale.</p>
        {demoScenarios.map((scenario) => (
          <button type="button" key={scenario.id} disabled={loading !== null} onClick={() => loadScenario(scenario.id)}>
            <span>{loading === scenario.id ? 'Caricamento…' : scenario.title}</span>
            <small>{scenario.description}</small>
          </button>
        ))}
      </div>
    </details>
  )
}
